/* eslint-disable */
import * as util from "@/api/toolkit";

const state = {

};

const mutations = {
};

const actions = {
    pickOperatorBySlug({ commit }, params) {
        return new Promise((resolve, reject) => {
            // console.log("params", params)
            util.pickOperatorBySlug(params).then(response => {
                console.log("params", params)

                resolve(response);
            }).catch(error => {
                reject(error);
            });
        });
    },
};


export default {
    namespaced: true,
    state,
    mutations,
    actions
};



// WEBPACK FOOTER //
// ./src/store/modules/toolkit.js